/**
 * http请求hook封装
 */
import axios, {type AxiosRequestConfig, type Method} from 'axios'
import 'vant/es/toast/style'
import configs from '@/config'
import {showToast} from 'vant'
import Cookies from 'js-cookie'

let baseUrl: string = configs.EVN.BASE_URL

interface UtimeResponse {
    code: number
    msg?: string
    data?: any
}

/**
 * 通用http请求封装
 * @param url 请求地址
 * @param requestConfig 请求配置
 * @param reqParams 请求参数
 */
export const httpRequest = (url: string, requestConfig: AxiosRequestConfig, reqParams?: Record<string, any>) => {
    if (requestConfig.method === 'GET' || requestConfig.method === 'DELETE') {
        requestConfig.params = reqParams || {}
    } else {
        requestConfig.data = reqParams || {}
    }
    return axios(url, requestConfig)
        .then(res => {
            return res
        })
        .catch(err => {
            console.error('useHttpRequest request.err -> ', requestConfig.method, url, reqParams, '\n             err -> ', err)
            if (err.message && err.message === 'Network Error') {
                showToast('网络连接失败，请稍后重试~')
                return Promise.reject('网络连接失败，请稍后重试~')
            } else if (err.message && err.message.indexOf('Request failed with status code') !== -1) {
                showToast('网络连接失败，请稍后重试~')
                return Promise.reject('网络连接失败，请稍后重试~')
            } else {
                showToast(err || '数据请求失败，请稍后重试~')
                return Promise.reject(err || '数据请求失败，请稍后重试~')
            }
        })
}

/**
 * Utime http请求封装，自行处理请求返回值
 * @param uri 请求地址
 * @param reqParams 请求参数
 * @param requestConfig axios请求配置
 * @param timeout 请求超时时间
 */
export const utimeHttpRequest = (uri: string, reqParams?: Record<string, any>, requestConfig?: AxiosRequestConfig, timeout?: number) => {
    if (sessionStorage.getItem('serverUrl') && sessionStorage.getItem('serverUrl') != 'undefined') {
        baseUrl = sessionStorage.getItem('serverUrl')
    }
    const url = uri.includes('https://') ? uri : `${baseUrl}${uri}`

    let RNPostData = localStorage.getItem('RNPostData')
    let token = ''
    if (RNPostData) {
        token = JSON.parse(RNPostData).token
    }
    const config: AxiosRequestConfig = {
        method: 'GET' as Method,
        headers: {
            'Access-Control-Allow-Origin': '*',
            appId: configs?.EVN?.appId || 6,
            'Content-Type': 'application/json',
            albumToken: Cookies.get('albumToken') || '',
            token
        },
        timeout: timeout || 30000,
        ...requestConfig
    }

    return httpRequest(url, config, reqParams)
        .then(res => {
            // console.log('res==>',res)
            if (String(res.status).startsWith('2')) {
                const data = <UtimeResponse>res.data
                if (data.code === 1) {
                    return data.data
                } else if (data.code === 2) {
                    showToast({
                        message: data.msg || '',
                        duration: 2000
                    })
                } else if (data.code === 4) {
                    if (!location.hash.includes('downLoadPackage')) {
                        const page404 = location.href.split('#')[0] + '#/404'
                        window.location.replace(`${page404}`)
                    }
                } else if (data.code === 8) {
                    showToast(data.msg || '')
                } else if (data.code === 9) {
                    if (!location.hash.includes('downLoadPackage')) {
                        const currentUrl = location.href
                        // 检查是否已经包含 title=close，避免重复添加
                        if (!currentUrl.includes('title=close')) {
                            const page404 = location.href.split('#')[0] + '&title=close' + '#/404'
                            // console.log('跳转至:', page404)
                            window.location.replace(page404)
                            // return Promise.reject(data.code)
                        } else {
                            console.warn('title=close 已存在，避免重复跳转')
                        }
                    }
                    // return Promise.reject(data.code)
                } else {
                    showToast(data.msg || '')
                    return res.data
                }
            }
        })
        .catch(err => {
            if (err.code == 'ECONNABORTED') {
                window.location.reload()
            }
        })
}
